module.exports = __webpack_public_path__ + "static/media/laservideo_scritta.3f55e563.png";